import { render, staticRenderFns } from "./Wp_mini_config.vue?vue&type=template&id=df3599e4&scoped=true&"
import script from "./Wp_mini_config.vue?vue&type=script&lang=js&"
export * from "./Wp_mini_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3599e4",
  null
  
)

export default component.exports